import { sectionalRankMetricSorter } from '@/pages/intelligence/_config/storeRank/utils';
import {
  // 单榜单筛选器
  SINGLE_SOURCE_SELECT as SINGLE_SOURCE_SELECT_FILTER,
  // 时间筛选器
  RANGE_TIME as RANGE_TIME_SELECT_FILTER,
  REGION as COUNTRY_REGION,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { GLOBAL_WO_CHINA, GLOBAL } from '@intelligence/utils/constant';
import type {
  IStoreRankDetailsDataFetchParams,
  IStoreRankDetailsResData,
  IStoreRankDetailsRankResData,
} from '@/pages/intelligence/types/storeRank';
import { getAllCountries } from '@/pages/intelligence/utils/regionSelectUtils';
import type { IBaseProps, IRegionType, IRegionValue } from '@/pages/intelligence/types/common';

export function GetRequest() {
  const url = location.search || ''; // 获取url中"?"符后的字串
  const theRequest = {};
  let strs: string[] = [];
  if (url?.indexOf('?') !== -1) {
    const str = url?.substring(1);
    strs = str?.split('&');
    for (let i = 0; i < strs?.length; i++) {
      // @ts-ignore
      theRequest[strs[i]?.split('=')?.[0]] = unescape(strs[i]?.split('=')?.[1]);
    }
  }
  return theRequest;
}

const sortResData = (
  data: IStoreRankDetailsResData[],
  sorter: (a: IStoreRankDetailsRankResData, b: IStoreRankDetailsRankResData) => number,
): IStoreRankDetailsResData[] => {
  if (!Array.isArray(data)) return [];
  return data.map((item) => {
    const metrics = item?.metric?.sort(sorter) ?? [];
    return {
      ...item,
      metric: metrics,
    };
  });
};

export const handleResData = (
  data: IStoreRankDetailsResData[],
  cfg: {
    isSectionalRank: boolean;
  },
): IStoreRankDetailsResData[] => {
  if (cfg?.isSectionalRank) return sortResData(data, sectionalRankMetricSorter);
  return data ?? [];
};

export const getAppIds = (appIdsData: any[]): string[] => {
  const result: string[] = [];
  if (!Array.isArray(appIdsData)) return [];
  for (const appIdData of appIdsData) {
    const appId = appIdData?.id;
    if (!appId) continue;
    result.push(appId);
  }
  return result;
};

// DetailStoreRank继承参加
export const getInitialFetchParamsDetailStoreRank = (
  isOperate: boolean,
  filterExtend: any,
  defaultFetchParams: IStoreRankDetailsDataFetchParams,
  activeSegment: string,
): IStoreRankDetailsDataFetchParams => {
  if (!isOperate) return defaultFetchParams;
  const singleSourceFilterExtend = filterExtend?.[SINGLE_SOURCE_SELECT_FILTER];

  const rangeTimeFilterExtend = filterExtend?.[RANGE_TIME_SELECT_FILTER];
  const regionFilterExtend = filterExtend?.[COUNTRY_REGION];
  const sourceExtend = singleSourceFilterExtend?.value;
  const countriesExtend = regionFilterExtend?.markets;

  let filterStartDate = defaultFetchParams?.start_date;
  let filterEndDate = defaultFetchParams?.end_date;
  // 这里只有日粒度，只需要继承日粒度时间
  if (rangeTimeFilterExtend?.time_type === 'day') {
    filterStartDate = rangeTimeFilterExtend?.start_date || defaultFetchParams?.start_date;
    filterEndDate = rangeTimeFilterExtend?.end_date || defaultFetchParams?.end_date;
  }

  let filterParamsValue = {
    ...defaultFetchParams,
    regions: countriesExtend?.length ? countriesExtend : defaultFetchParams?.regions,
    start_date: filterStartDate,
    end_date: filterEndDate,
  };

  if (activeSegment === 'market') {
    filterParamsValue = {
      ...filterParamsValue,
      source: sourceExtend ? [sourceExtend] : defaultFetchParams?.source,
    };
  }

  return filterParamsValue;
};

// 转换 GLOBAL_WO_CHINA, GLOBAL为当前国家范围的单独国家数组
export const getMarketsValue = (regions: any, regionOptions: any[]) => {
  if (!(Array.isArray(regions) && regions?.length > 0)) return regions;
  const switchKey = regions[0] || '';
  switch (switchKey) {
    case GLOBAL:
      return getAllCountries(regionOptions);
    case GLOBAL_WO_CHINA:
      return getAllCountries(regionOptions)?.filter((item) => item !== 'cn');
    default:
      return regions;
  }
};

// 获取国家数组的国家keylist
export const getMarketKeyList = (regions: any[]) => {
  return regions?.map((item: any) => item.market) || [];
};
